<div class="dialog-content">
  <div class="close-button-container">
    <app-modal-close-button
      [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
  </div>
  <div style="display: flex; gap: 18px">
    <mat-icon class="error-icon" svgIcon="error-icon"></mat-icon>
    <app-inactive-resident-message
      [resident]="data.resident"
      [closeDialog]="closeDialog.bind(this)"></app-inactive-resident-message>
  </div>
</div>
